interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'Article' | 'FAQPage';
  data?: Record<string, unknown>;
}

export default function SchemaOrg({ type, data = {} }: SchemaOrgProps) {
  const baseSchemas: Record<string, Record<string, unknown>> = {
    Organization: {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '小蓝视频',
      url: 'https://www.xiaolanvideo.com',
      description: '小蓝视频汇聚香蕉视频、糖豆视频、茄子视频、糖心视频等热门平台高清免费在线观看',
      sameAs: [
        'https://weibo.com/xiaolanvideo',
        'https://www.xiaolanvideo.com',
      ],
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '400-888-6688',
        contactType: 'customer service',
        email: 'contact@xiaolanvideo.com',
      },
      ...data,
    },
    WebSite: {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '小蓝视频',
      url: 'https://www.xiaolanvideo.com',
      description: '小蓝视频汇聚香蕉视频、糖豆视频、茄子视频、糖心视频等热门平台高清免费在线观看',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://www.xiaolanvideo.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
      ...data,
    },
    WebPage: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: '小蓝视频',
      url: 'https://www.xiaolanvideo.com',
      description: '小蓝视频汇聚香蕉视频、糖豆视频、茄子视频、糖心视频等热门平台高清免费在线观看',
      ...data,
    },
    Article: {
      '@context': 'https://schema.org',
      '@type': 'Article',
      ...data,
    },
    FAQPage: {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      ...data,
    },
  };

  const schema = baseSchemas[type] || {};

  return (
    <script type="application/ld+json">{JSON.stringify(schema)}</script>
  );
}